module.exports = __webpack_public_path__ + "img/4-shaman-helper_v8e_loading.46194d41.jpg";